<app-news-link [news]="news" [utmParams]="linkUtmParams">
  <div class="top-news-card__link" [class.padding]="!isLarge">
    <div class="top-news-card__info" [class.large]="isLarge">
      <h2 *ngIf="preTitle?.length > 0" [innerHTML]="preTitle"></h2>
      <h1 *ngIf="title" [innerHTML]="title"></h1>
      <h1 *ngIf="!title" [innerHTML]="preview_text"></h1>
      <div *ngIf="false" class="top-news-card__author">
        <div class="top-news-card__logo-wrapper"
             [ngStyle]="{background: authorBackground ? authorBackground : '#fff'}">
          <img *ngIf="authorImgUrl"
               [lazyLoad]="lazyLoadImage"
               alt="Top news author"
               [src]="authorImgUrl">
        </div>
        <h4>
          {{authorName}}
        </h4>
      </div>
    </div>
    <lib-lazy-image *ngIf="picture"
                    [preload]="preloadImage"
                    [lazyLoad]="lazyLoadImage"
                    [picture]="picture"
                    [targetRes]="targetRes"
                    alt="Top news" class="top-news-card__bg-img"></lib-lazy-image>
  </div>
</app-news-link>
